import setting from '@/setting'
import { cloneDeep } from 'lodash'
import MainLayout from '@/layout'

const files = require.context('./modules', false, /\.js$/)
const _import = require(`@/utils/import.${process.env.NODE_ENV === 'development' ? 'dev' : 'prod'}`)

/**
 * 附加数据属性名称
 * disableAuth:禁止检验权限
 * disableMenu:禁用菜单
 * disableRouter:禁用路由
 * fixedTab:固定tab
 * disableTab:禁用tab
 * tabCache:tab缓存
 * disableTabCache:禁用tab缓存
 * title:标题
 * icon:图标
 */
const metaKeys = [
  'disableAuth',
  'disableMenu',
  'disableRouter',
  'fixedTab',
  'disableTab',
  'tabCache',
  'disableTabCache',
  'title',
  'icon'
]
//菜单顺序
const menuSort = ['system', 'price', 'sale', 'mes', 'quality', 'style','tune', 'factory', 'material', 'manage']

/**
 * 获取router完整路径
 */
function getPath(router, parentRouter) {
  return parentRouter && parentRouter.path
    ? `${parentRouter.path}${parentRouter.path !== '/' ? '/' : ''}${router.path}`
    : router.path
}

/**
 * 获取router名称
 */
function getName(router, parentRouter) {
  let path = router.path
  path = path.replace(/\//g, '-')
  return parentRouter && parentRouter.name ? `${parentRouter.name}-${path}` : path.substring(1)
}

/**
 * 路径是否为网页
 */
function isExternal(router) {
  return router.path && /^(https?:|mailto:|tel:)/.test(router.path)
}

/**
 * 移除原始数据中指定metaKeys中参数为true的路由
 */
function removeRouterFormMetaKey(routers, metaKeys) {
  const targetRouters = routers.filter(router => !metaKeys.find(metakey => router[metakey]))
  targetRouters.forEach(item => {
    if (item.children) {
      item.children = removeRouterFormMetaKey(item.children, metaKeys)
    }
  })
  return targetRouters
}

/**
 * 获取已经授权的路由
 */
function getAuthorizeRouters(routers, permissions = [], parentPath) {
  let authorizeRouters = routers.filter(router => isRouterAuthorize(router, permissions, parentPath))
  authorizeRouters.forEach(router => {
    if (router.children) {
      router.children = getAuthorizeRouters(router.children, permissions, getPath(router, { path: parentPath }))
    }
  })
  return authorizeRouters.filter(
    router => (router.children && router.children.length > 0) || router.component || isExternal(router)
  )
}

/**
 * 路由是否授权
 */
function isRouterAuthorize(router, permissions, parentPath) {
  let path = isExternal(router) ? router.path : getPath(router, { path: parentPath })
  return !setting.isAuthorize || router.disableAuth || permissions.findIndex(item => path === item) !== -1
}

/**
 * 将数据处理为vue指定的路由格式
 */
function handleRouterProperty(router, parentRouter) {
  router.name = getName(router, parentRouter)
  router.meta = {}
  metaKeys
    .filter(key => key in router)
    .forEach(key => {
      router.meta[key] = router[key]
      delete router[key]
    })
  if (!parentRouter || router.component) {
    router.component = parentRouter ? _import(router.component) : MainLayout
  }
  if (router.children) {
    router.redirect = `${parentRouter ? parentRouter.redirect : router.path}${router.path !== '/' ? '/' : ''}${
      router.children[0].path
    }`
    router.children.forEach(item => handleRouterProperty(item, router))
  }
}

/**
 * 获取转换后的router
 */
function getConvertRouters(routers, parentRouter) {
  const list = [...routers]
  routers.forEach(router => {
    router.path = getPath(router, parentRouter)
    router.children && list.push(...getConvertRouters(router.children, router))
  })
  list.forEach(router => delete router.children)
  return list
}

/**
 * 将数据处理为菜单需要的格式
 */
function handleMenuProperty(menu, parentMenu) {
  menu.name = isExternal(menu) ? menu.path : getName(menu, parentMenu)
  menu.path = isExternal(menu) ? menu.path : getPath(menu, parentMenu)
  if (menu.children) {
    menu.children.forEach(item => handleMenuProperty(item, menu))
  }
}

/**
 * 获取转换后的tab
 */
function getConvertTabs(tabs) {
  const list = tabs.filter(tab => tab.component)
  list.forEach(tab => delete tab.component)
  tabs.forEach(tab => tab.children && list.push(...getConvertTabs(tab.children)))
  return list
}

/**
 * 获取默认路由
 */
function getDefaultRouter() {
  return [
    {
      path: '/login',
      name: 'login',
      meta: { disableAuth: true },
      component: _import('system/login')
    },
    {
      path: '/manual',
      name: 'manual',
      meta: { disableAuth: true },
      component: _import('system/manual')
    },
    {
      path: '*',
      name: '404',
      meta: { disableAuth: true },
      component: _import('system/error')
    }
  ]
}

export default {
  routers: permissions => {
    let routers = cloneDeep(files.keys().map(key => files(key).default))
    routers = removeRouterFormMetaKey(routers, ['disableRouter'])
    routers = getAuthorizeRouters(routers, permissions)
    routers.forEach(item => handleRouterProperty(item))
    routers.forEach(item => item.children && (item.children = [...getConvertRouters(item.children)]))
    return [...getDefaultRouter(), ...routers]
  },
  menus: permissions => {
    let menus = cloneDeep(menuSort.map(key => files(`./${key}.js`).default))
    menus = removeRouterFormMetaKey(menus, ['disableMenu'])
    menus = getAuthorizeRouters(menus, permissions)
    menus.forEach(item => handleMenuProperty(item))
    return menus
  },
  tabs: permissions => {
    let tabs = cloneDeep(files.keys().map(key => files(key).default))
    tabs = removeRouterFormMetaKey(tabs, ['disableRouter', 'disableTab'])
    tabs = getAuthorizeRouters(tabs, permissions)
    tabs.forEach(item => handleMenuProperty(item))
    tabs = getConvertTabs(tabs)
    return tabs
  }
}
